var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.34326 11.2197V15.7097C3.34326 20.1997 5.14326 21.9997 9.63326 21.9997H15.0233C19.5133 21.9997 21.3133 20.1997 21.3133 15.7097V11.2197",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3332 12C14.1632 12 15.5132 10.51 15.3332 8.68L14.6732 2H10.0032L9.33324 8.68C9.15324 10.51 10.5032 12 12.3332 12Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.6433 12C20.6633 12 22.1433 10.36 21.9433 8.35L21.6633 5.6C21.3033 3 20.3033 2 17.6833 2H14.6333L15.3333 9.01C15.5033 10.66 16.9933 12 18.6433 12Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.97313 12C7.62313 12 9.11313 10.66 9.27313 9.01L9.49313 6.8L9.97313 2H6.92313C4.30313 2 3.30313 3 2.94313 5.6L2.67313 8.35C2.47313 10.36 3.95313 12 5.97313 12Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.3333 17C10.6633 17 9.83325 17.83 9.83325 19.5V22H14.8333V19.5C14.8333 17.83 14.0033 17 12.3333 17Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/Marketplace.9b92f5b3abfe11f7644fe72bd2023a33.svg";
export { ForwardRef as ReactComponent };